import React from "react";
import "../About.css";
import {
    FaLightbulb,
    FaUsers,
    FaShieldAlt,
    FaRocket,
} from "react-icons/fa";

const About = () => {
    return (
        <section className="about">

            <div className="about-container">

                <span className="section-tag">
                    THE VISION BEHIND VISIONVOTE
                </span>

                <h2>
                    Empowering Businesses Through
                    <span> Innovation & Technology</span>
                </h2>

                <p className="about-intro">
                    VisionVote Technologies Private Limited is a forward-thinking software
                    development and technology consulting company that empowers startups,
                    enterprises, and growing businesses with innovative digital solutions.
                    By combining strategic IT consulting, modern software engineering, artificial
                    intelligence, cloud technologies, and agile development practices, we help
                    organizations transform ideas into scalable digital products, optimize
                    business operations, and achieve long-term success in an evolving digital
                    landscape.
                </p>

                <div className="about-content">

                    <p>
                        We specialize in delivering custom software, enterprise
                        applications, AI-powered solutions, cloud-native platforms, and
                        modern web and mobile applications tailored to the unique needs of
                        businesses across industries.
                    </p>

                    <p>
                        Our development philosophy combines innovation, technical
                        excellence, and agile methodologies to create secure, scalable,
                        and high-performing digital products that solve real business
                        challenges.
                    </p>

                    <p>
                        From strategy and UI/UX design to development, deployment, and
                        long-term maintenance, we work as a trusted technology partner,
                        helping organizations embrace digital transformation with
                        confidence.
                    </p>

                </div>

                <div className="about-features">

                    <div className="feature-card">
                        <FaLightbulb />
                        <h4>Innovation First</h4>
                        <p>We transform creative ideas into powerful digital solutions.</p>
                    </div>

                    <div className="feature-card">
                        <FaUsers />
                        <h4>Client Focused</h4>
                        <p>Every project is built around our clients' business goals.</p>
                    </div>

                    <div className="feature-card">
                        <FaShieldAlt />
                        <h4>Secure & Reliable</h4>
                        <p>Enterprise-grade security and scalable architecture.</p>
                    </div>

                    <div className="feature-card">
                        <FaRocket />
                        <h4>Future Ready</h4>
                        <p>Modern technologies designed for long-term business growth.</p>
                    </div>

                </div>

                <div className="home-philosophy">

                    <span>OUR PHILOSOPHY</span>

                    <blockquote>
                        "Technology should simplify complexity, inspire innovation, and
                        create opportunities for businesses to grow. At VisionVote
                        Technologies, we don't just build software—we build trusted digital
                        partnerships that deliver lasting value."
                    </blockquote>

                </div>

            </div>

        </section>
    );
};

export default About;